import template from './imgFlag.html';

export default {
  template,
  controllerAs: 'vm',
  bindings: {
    class: '@',
    countryCode: '<',
  },
};
